import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin, map, switchMap, take, tap } from 'rxjs';
import { AppRoutes } from 'src/app/app-routes';
import { GtmService } from 'src/app/services/gtm/gtm.service';
import { LoaderService } from 'src/app/services/loader/loader.service';
import { StepperService } from 'src/app/services/stepper/stepper.service';
import { StoreService } from 'src/app/services/store/store.service';
import { PURPOSES_ID_BY_PRODUCT, QUERY_PARAMS, Steps } from 'src/app/utils/constants';

@Component({
	selector: 'app-main',
	templateUrl: './main.component.html',
	styleUrls: ['./main.component.scss'],
})
export class MainComponent {
	readonly steps = Steps;
	readonly stepActive$ = this.stepperService.stepActive$;
	readonly loader$ = this.loaderService.loader$;

	readonly init$ = this.route.queryParamMap.pipe(
		take(1),
		map(params => ({
			product: params.get(QUERY_PARAMS.PRODUCT)?.trim() ?? '',
			origin: params.get(QUERY_PARAMS.ORIGIN)?.trim() ?? 'desconocido',
		})),
		tap(({ product, origin }) => this.gtmservice.setExtras({ flujo: product, origen: origin })),
		switchMap(({ product }) =>
			forkJoin({
				params: this.storeService.initialParameters(product),
				consentPj: this.storeService.getPurposes(PURPOSES_ID_BY_PRODUCT[product]),
			})
		),
		tap(() => this.router.navigate([AppRoutes.COMPANY_DATA]))
	);

	constructor(
		private readonly loaderService: LoaderService,
		private readonly stepperService: StepperService,
		private readonly storeService: StoreService,
		private readonly gtmservice: GtmService,
		private readonly route: ActivatedRoute,
		private readonly router: Router
	) {}
}
